import { render, staticRenderFns } from "./no-subsidy-button.vue?vue&type=template&id=018c9a76&scoped=true&lang=pug&"
import script from "./no-subsidy-button.vue?vue&type=script&lang=js&"
export * from "./no-subsidy-button.vue?vue&type=script&lang=js&"
import style0 from "./no-subsidy-button.vue?vue&type=style&index=0&id=018c9a76&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018c9a76",
  null
  
)

export default component.exports